import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { message, Select } from "antd";
import { DropdownSuffix } from "icons";
import { useEffect, useState } from "react";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";

export const UpdateCaseStatus = ({
  caseTotalStatuses,
  caseStatus,
  caseId,
  refetchCases,
}) => {
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();
  const [caseStatusLocal, setCaseStatusLocal] = useState(caseStatus);

  const [
    updateStatus,
    {
      data: updateStatusData,
      isLoading: updateStatusLoading,
      error: updateStatusErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  async function handleSelectStatus(statusId) {
    setCaseStatusLocal(statusId);
    try {
      const res = await updateStatus({
        params: {
          case_id: caseId,
          statusId,
          loggedUser: user?.email,
        },
      });

      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        refetchCases();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const statusDropdownData = caseTotalStatuses?.map((item) => ({
    label: item?.settingName,
    value: item?.settingId,
  }));

  return (
    <div className={styles.statusUpdate} style={{ marginLeft: "12px" }}>
      <div className={`${styles.dropdown} ${styles?.[caseStatus]}`}>
        <Select
          dropdownStyle={{ minWidth: "250px" }}
          defaultValue={caseStatus}
          showSearch
          value={caseStatusLocal}
          filterOption={(
            input,
            option, // 👈 filter logic
          ) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          style={{
            // width: "180px",
            height: "4.3dvh",
            overflow: "hidden",
          }}
          onSelect={handleSelectStatus}
          options={statusDropdownData}
          suffixIcon={<DropdownSuffix height={12} width={12} />}
        />
      </div>
    </div>
  );
};
